import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@hooks/useAuth'
import { ROUTES } from './paths'
import type { UserRole } from '@features/auth/authTypes'

interface ProtectedRouteProps {
  children: ReactNode
  roles?: UserRole[]
}

export const ProtectedRoute = ({ children, roles }: ProtectedRouteProps) => {
  const { isAuthenticated, user } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />
  }

  if (roles && roles.length > 0 && !roles.includes(user?.role ?? '')) {
    return <Navigate to={ROUTES.dashboard} replace />
  }

  return <>{children}</>
}
